import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";

// Handles Supabase OAuth callback (Google/etc.). The supabase-js client
// auto-detects the session in URL (detectSessionInUrl: true). We just wait
// for the session to be established, then redirect.
const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    const start = Date.now();
    const check = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (cancelled) return;
      if (session) navigate("/dashboard", { replace: true });
      else if (Date.now() - start > 8000) navigate("/login", { replace: true });
      else setTimeout(check, 300);
    };
    check();
    return () => { cancelled = true; };
  }, [navigate]);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center gap-4 bg-paper">
      <div className="w-10 h-10 border-2 border-sage-deep border-t-transparent rounded-full animate-spin" />
      <p className="text-stone text-sm uppercase tracking-[0.2em]">Iniciando sesión…</p>
    </div>
  );
};

export default AuthCallback;
